import React from 'react';
import { useConfig } from '../../ConfigContext';

export default function ZoomControl() {
  const {
    general,
    setGeneralState,
    handleZoomMinus,
    handleZoomPlus,
    socials,
    setSocialsState,
  } = useConfig();

  return (
    <div>
      {general.imageSrc && (
        <div className="w-full flex items-center zooming">
          <label htmlFor="zoom" className="custom-label flex-1">
            Přiblížení fotografie
          </label>
          <button onClick={() => handleZoomMinus('general')}>-</button>
          <input
            id="zoom"
            type="range"
            min="1"
            max="7"
            step="0.1"
            value={general.zoom}
            onChange={(e) =>
              setGeneralState({ zoom: parseFloat(e.target.value) })
            }
            className="w-full flex-1 w-[50%]"
            style={{
              background: '#874fb7',
              color: '#874fb7',
            }}
          />
          <button onClick={() => handleZoomPlus('general')}>+</button>
          <div className="text-sm text-gray-500 mt-1 items-center flex-1">
            zoom:
            <span className="font-semibold">
              {Number(general.zoom).toFixed(1)}×
            </span>
          </div>
        </div>
      )}

      {socials.profilePicture && general.glassType === 'socials' && (
        <div className="w-full flex items-center zooming">
          <label htmlFor="zoom" className="custom-label flex-1">
            Přiblížení Profilu
          </label>
          <button onClick={() => handleZoomMinus('socials')}>-</button>
          <input
            id="zoom"
            type="range"
            min="1"
            max="7"
            step="0.1"
            value={socials.zoom}
            onChange={(e) =>
              setSocialsState({ zoom: parseFloat(e.target.value) })
            }
            className="w-full flex-1 w-[50%]"
            style={{
              background: '#874fb7',
              color: '#874fb7',
            }}
          />
          <button onClick={() => handleZoomPlus('socials')}>+</button>
          <div className="text-sm text-gray-500 mt-1 items-center flex-1">
            zoom: <span className="font-semibold">{socials.zoom}×</span>
          </div>
        </div>
      )}
    </div>
  );
}
